enum NotificationType {
	error = 'error',
	success = 'success',
	warning = 'warning',
	info = 'info'
}

export default NotificationType;
